import { Repository } from '@/forms/api/repository-factory';
import getParams from '@/forms/helpers/get-params';
import { DECISION } from '@/forms/constants/services';

const resource = '/income/verification/transaction/status/v1.0';

export default {
  isUserAllowed(payload) {
    return Repository.post(`${resource}`, payload, {
      params: getParams(DECISION),
    });
  },
};
